/**
 * Image Slider Module
 *
 * Handles image carousel functionality with auto-advance and arrow navigation.
 */

const DEFAULT_INTERVAL = 5000;

/**
 * Initialize a single image slider
 */
function initSlider(slider) {
  const track = slider.querySelector(".image-slider__track");
  const slides = slider.querySelectorAll(".image-slider__slide");
  const prevBtn = slider.querySelector(".image-slider__arrow--prev");
  const nextBtn = slider.querySelector(".image-slider__arrow--next");
  const slideCount = slides.length;

  if (slideCount === 0) {
    return;
  }

  let currentIndex = 0;
  let autoSlideInterval;

  /**
   * Navigate to a specific slide
   */
  function goToSlide(index) {
    currentIndex = index;
    track.style.transform = `translateX(-${100 * index}%)`;
  }

  /**
   * Advance to the next slide
   */
  function nextSlide() {
    goToSlide((currentIndex + 1) % slideCount);
  }

  /**
   * Go to previous slide
   */
  function prevSlide() {
    goToSlide((currentIndex - 1 + slideCount) % slideCount);
  }

  /**
   * Start auto-sliding
   */
  function startAutoSlide() {
    const interval = parseInt(slider.dataset.interval, 10) || DEFAULT_INTERVAL;
    autoSlideInterval = setInterval(nextSlide, interval);
  }

  /**
   * Stop auto-sliding
   */
  function stopAutoSlide() {
    clearInterval(autoSlideInterval);
  }

  // Arrow navigation
  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      stopAutoSlide();
      prevSlide();
      startAutoSlide();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      stopAutoSlide();
      nextSlide();
      startAutoSlide();
    });
  }

  // Touch/swipe support
  let touchStartX = 0;
  let touchStartY = 0;
  let isSwiping = false;

  slider.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
      stopAutoSlide();
    },
    { passive: true },
  );

  slider.addEventListener(
    "touchmove",
    (e) => {
      if (!isSwiping) {
        const dx = Math.abs(e.touches[0].clientX - touchStartX);
        const dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > dy && dx > 10) {
          isSwiping = true;
        }
      }
      if (isSwiping) {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  slider.addEventListener(
    "touchend",
    (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const diff = touchStartX - touchEndX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }

      if (slider.dataset.autoSlide === "true") {
        startAutoSlide();
      }
    },
    { passive: true },
  );

  // Set up auto-slide with pause on hover
  if (slider.dataset.autoSlide === "true") {
    startAutoSlide();
    slider.addEventListener("mouseenter", stopAutoSlide);
    slider.addEventListener("mouseleave", startAutoSlide);
  }
}

/**
 * Initialize all image sliders on the page
 */
export function init() {
  const sliders = document.querySelectorAll(".image-slider");
  sliders.forEach(initSlider);
}
